import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useProjectsSignatureStatusQuery({ projectId }) {
  return useQuery({
    queryKey: ['projects', projectId, 'signatureStatus'],
    queryFn: async () => {
      const response = await axios.get(
        `/projects/${projectId}/signature_status`,
      );

      return response.data;
    },
    select: (data) => formatData({ data, resourceTypes: ['version'] }),
  });
}
